import type { ScopedDenial as ScopedDenialModel } from '@/adapters/catalogv1.g';

export function extractScopedDenial(model: ScopedDenialModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    principalRef: model.principal_ref ?? '',
    principalType: model.principal_type ?? '',
    permissionRef: model.permission_ref ?? '',
    scopeRef: model.scope_ref ?? '',
    scopeKind: model.scope_kind ?? '',
    effect: model.effect ?? '',
    condition: model.condition ?? '',
    policyRef: model.policy_ref ?? '',
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogScopedDenial = ReturnType<typeof extractScopedDenial>;
